import React, { Fragment } from 'react'

import wrapField from '../shared/wrapField'
import { Info } from 'media/icons'

import styles from './TextArea.module.scss'

const Field = ({ smartSubmit, fieldState, fieldApi, forwardedRef, noForm, withInfo, infoText, onSwitchInfo, resolvePlaceholder, ...props }) => {
	const isForm = fieldState && fieldApi
	const standardProps = {
		placeholder: resolvePlaceholder('textarea'),
		...props
	}
	const textareaProps = isForm ? {
		...standardProps,
		onChange(e) {
			const { value } = e.target
			fieldApi.setValue(value)
			fieldApi.setTouched()
			if(typeof props.onChange === 'function') {
				props.onChange(e)
			}
			if(smartSubmit) {
				smartSubmit.delay(e)
			}
		},
		onBlur(e) {
			if(smartSubmit) {
				smartSubmit.submit(e)
			}
			if(props.onBlur) {
				props.onBlur(e)
			}
		},
		value: fieldState.value || ''
	} : standardProps
	const textareaClass = props['ta-class'] ? styles[props['ta-class']] : ''
	return(
		<Fragment>
			<div className={styles.wrapper}>
				{/* <textarea ref={forwardedRef} {...textareaProps} style={props['ta-style']} /> */}
				<textarea ref={forwardedRef} {...textareaProps} className={textareaClass} />
				{withInfo && <Info className={styles['info-btn']} onClick={onSwitchInfo} />}
			</div>
			{withInfo && <div style={{ ...!infoText && { visibility: 'hidden' } }} className={styles['info-block']}>{infoText}</div>}
		</Fragment>
	)
}

export default wrapField(Field)
